import React, { Component } from 'react';
import './User.css';
import { Button, Form, FormGroup, Label, Input, FormText } from 'reactstrap';
import axios from 'axios';
import { env } from '../../environment';
// import firebase from '../../firebase';

class User extends Component {

    constructor(props){
        super(props);
        this.state ={
            id: "",
            showMessage : false,
            type : "",
            purpose : "",
            name : "",
            email : "",
            contactNumber : "",
            message : ""
        }
    }

    componentDidMount() {
        if (this.props.match.params.id) {
            document.title = 'Edit User';
            axios.get( env + `user/getUserById?id=` + this.props.match.params.id)
            .then(res => {
                const user = res.data;
                this.setState({ 
                    id : this.props.match.params.id, 
                    type : user.type, 
                    purpose : user.purpose, 
                    name : user.name,
                    email : user.email,
                    contactNumber : user.contactNumber,
                    message : user.message    
                });
            })
        }

    }

    /*componentWillReceiveProps(nextProps) {
        if (!nextProps.params) {
            document.title = 'Add User';
            this.setState({ 
                userName : "",
                userUsername : "",
                userDisplayName : "",
                userEmail : "",
                userDescription : "",
                fileName : ""
            });
        }
    }*/

    editUser(){
            const data = {
                    "id": this.state.id,
                    "type": this.state.type,
                    "purpose": this.state.purpose,
                    "name": this.state.name,
                    "email": this.state.email,
                    "contactNumber": this.state.contactNumber,
                    "message" : this.state.message
                  }
              
            axios.put( env + `user/update`, data)
            .then(res => {
                this.setState({ showMessage : true})
                    setTimeout(() => { this.setState({ showMessage : false }); this.props.history.push("/home"); }, 1000);
            })
    }

    deleteUser(){
        axios.delete( env + `user/delete?id=` + this.props.match.params.id)
            .then(res => {
                this.props.history.push("/home");
            })
    }

  
    render () {
          return (
            <div className="userContainer">
            <div className="userHeader">Edit User</div>
            <Form>
                <FormGroup>
                    <Label for="type">Type</Label>
                    <Input type="text" name="type" id="type" value={this.state.type} onChange= {(e) => this.setState({type : e.target.value})} />
                </FormGroup>
                <FormGroup>
                    <Label for="purpose">Purpose</Label>
                    <Input type="text" name="purpose" id="purpose" value={this.state.purpose} onChange= {(e) => this.setState({purpose : e.target.value})} />
                </FormGroup>
                <FormGroup>
                    <Label for="name">Name</Label>
                    <Input type="text" name="name" id="name" value={this.state.name} onChange= {(e) => this.setState({name : e.target.value})} />
                </FormGroup>
                <FormGroup>
                    <Label for="email">Email</Label>
                    <Input type="email" name="email" id="email" value={this.state.email} onChange= {(e) => this.setState({email : e.target.value})} />
                </FormGroup>
                <FormGroup>
                    <Label for="contactNumber">Contact Number</Label>
                    <Input type="text" name="contactNumber" id="contactNumber" value={this.state.contactNumber} onChange= {(e) => this.setState({contactNumber  : e.target.value})} />
                </FormGroup>
                <FormGroup>
                    <Label for="message">Message</Label>
                    <Input type="textarea" maxLength={280} name="message" id="message" value={this.state.message} onChange= {(e) => this.setState({message : e.target.value})}/>
                 </FormGroup>

                <div style={{textAlign:'center', marginBottom: '15px'}}><Button color="warning" style={{color:"white"}} onClick={() => this.editUser()} disabled={ this.state.type.trim() === "" || this.state.purpose.trim() === "" || this.state.name.trim() === "" || this.state.email.trim() === "" || this.state.contactNumber.trim() === ""  }>Update</Button> <Button color="danger" onClick={() => this.deleteUser()}>Delete</Button></div>
                
                <div className={this.state.showMessage ? 'showMessage' : 'hideMessage'}>Updated Successfully</div>
            </Form>

          </div>
          )
    }
  }
  
  export default User